import App from 'App';
import DgcOrdersPage from 'pages/DgcOrders';
import DigitalGiftCardsPage from 'pages/DigitalGiftCards';
import ErrorPage from 'pages/Error';
import LandingPage from 'pages/LandingPage';
import PhysicalOrdersPage from 'pages/PhysicalOrders';
import { Navigate, Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import DefaultLayout from 'shared/layout/DefaultLayout';

export const routeBuilder = {
  root: () => '/',
  error: (code?: number) => `/error${code ? `?code=${code}` : ''}`,
  giftCards: () => '/gift-cards',
  dgcOrders: () => '/dgc-orders',
  physicalOrders: () => '/physical-orders',
};

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route element={<DefaultLayout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="error" element={<ErrorPage />} />
        <Route path="gift-cards" element={<DigitalGiftCardsPage />} />
        <Route path="dgc-orders" element={<DgcOrdersPage />} />
        <Route path="physical-orders" element={<PhysicalOrdersPage />} />
        <Route path="*" element={<Navigate to="/error?code=404" />} />
      </Route>
    </Route>
  )
);
